/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './listReposByCollection.defs.js'
export * as $defs from './listReposByCollection.defs.js'
